"use strict";
// Copyright (C) 2017-2023 Smart code 203358507
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useShell_1 = __importDefault(require("./useShell"));
var useSettings_1 = __importDefault(require("./useSettings"));
var useFullscreen = function () {
    var shell = (0, useShell_1.default)();
    var settings = (0, useSettings_1.default)()[0];
    var _a = (0, react_1.useState)(false), fullscreen = _a[0], setFullscreen = _a[1];
    var requestFullscreen = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shell.active) return [3 /*break*/, 1];
                    shell.send('win-set-visibility', { fullscreen: true });
                    return [3 /*break*/, 5];
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    if (!document.documentElement.requestFullscreen) return [3 /*break*/, 3];
                    return [4 /*yield*/, document.documentElement.requestFullscreen()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    err_1 = _a.sent();
                    // Some browsers may reject the promise if not initiated by a user gesture
                    // or if permissions disallow fullscreen. We fail gracefully.
                    // eslint-disable-next-line no-console
                    console.warn('Fullscreen request failed:', err_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }, []);
    var exitFullscreen = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shell.active) return [3 /*break*/, 1];
                    shell.send('win-set-visibility', { fullscreen: false });
                    return [3 /*break*/, 5];
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    if (!(document.fullscreenElement === document.documentElement && document.exitFullscreen)) return [3 /*break*/, 3];
                    return [4 /*yield*/, document.exitFullscreen()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    err_2 = _a.sent();
                    // eslint-disable-next-line no-console
                    console.warn('Exit fullscreen failed:', err_2);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }, []);
    var toggleFullscreen = (0, react_1.useCallback)(function () {
        fullscreen ? exitFullscreen() : requestFullscreen();
    }, [fullscreen]);
    (0, react_1.useEffect)(function () {
        var onWindowVisibilityChanged = function (state) {
            setFullscreen(state.isFullscreen === true);
        };
        var onFullscreenChange = function () {
            setFullscreen(document.fullscreenElement === document.documentElement);
        };
        var onKeyDown = function (event) {
            var activeElement = document.activeElement;
            var inputFocused = activeElement &&
                (activeElement.tagName === 'INPUT' ||
                    activeElement.tagName === 'TEXTAREA' ||
                    activeElement.tagName === 'SELECT' ||
                    activeElement.isContentEditable);
            if (event.code === 'Escape' && settings.escExitFullscreen) {
                exitFullscreen();
            }
            if (event.code === 'KeyF' && !inputFocused) {
                toggleFullscreen();
            }
            if (event.code === 'F11' && shell.active) {
                toggleFullscreen();
            }
        };
        shell.on('win-visibility-changed', onWindowVisibilityChanged);
        document.addEventListener('keydown', onKeyDown);
        document.addEventListener('fullscreenchange', onFullscreenChange);
        return function () {
            shell.off('win-visibility-changed', onWindowVisibilityChanged);
            document.removeEventListener('keydown', onKeyDown);
            document.removeEventListener('fullscreenchange', onFullscreenChange);
        };
    }, [settings.escExitFullscreen, toggleFullscreen]);
    return [fullscreen, requestFullscreen, exitFullscreen, toggleFullscreen];
};
exports.default = useFullscreen;
